export default [
	{
		question: 'On the road to retirement, I am:',
		answers: [
			{
				answer: 'Retired, I made it!',
				picRef: '/Tools/rqanalyzerform/icons/q1/retired.png',
				value: 1
			},
			{
				answer: 'Less than five years away',
				picRef: '/Tools/rqanalyzerform/icons/q1/5.png',
				value: 4
			},
			{
				answer: 'Five to 10 years away',
				picRef: '/Tools/rqanalyzerform/icons/q1/5-10.png',
				value: 7
			},
			{
				answer: 'More than 10 years away',
				picRef: '/Tools/rqanalyzerform/icons/q1/10plus.png',
				value: 10
			}
		]
	},
	{
		question:
			'What decline in value of your investments would affect your ability to sleep at night or focus on work and other activities?',
		answers: [
			{
				answer: 'Any decline in value',
				picRef: '/Tools/rqanalyzerform/icons/q2/no-decline.png',
				value: 1
			},
			{
				answer: 'More than a 10 percent decline.',
				picRef: '/Tools/rqanalyzerform/icons/q2/less-than-10.png',
				value: 4
			},
			{
				answer: 'More than a 25 percent decline.',
				picRef: '/Tools/rqanalyzerform/icons/q2/less-than-25.png',
				value: 7
			},
			{
				answer: 'I can accept any level of decline in value.',
				picRef: '/Tools/rqanalyzerform/icons/q2/any-decline.png',
				value: 10
			}
		]
	},
	{
		question:
			'My current and future income sources, like salary, pension, Social Security, and more, are:',
		answers: [
			{
				answer: 'Very Stable',
				picRef: '/Tools/rqanalyzerform/icons/q3/very-stable.png',
				value: 1
			},
			{
				answer: 'Somewhat Stable',
				picRef: '/Tools/rqanalyzerform/icons/q3/somewhat-stable.png',
				value: 4
			},
			{
				answer: 'Very Unstable',
				picRef: '/Tools/rqanalyzerform/icons/q3/very-unstable.png',
				value: 7
			},
			{
				answer: "I don't have any retirement income sources.",
				picRef: '/Tools/rqanalyzerform/icons/q3/no-retirement-income.png',
				value: 10
			}
		]
	},
	{
		question: 'My Key Financial Goal is:',
		answers: [
			{
				answer: 'Preserving my Retirement Income Savings',
				picRef: '/Tools/rqanalyzerform/icons/q4/preserving.png',
				value: 1
			},
			{
				answer: 'Building an Estate and Providing for Further Generations',
				picRef: '/Tools/rqanalyzerform/icons/q4/building-for-future.png',
				value: 4
			},
			{
				answer: 'Getting the Most Income out of my Retirement Savings',
				picRef: '/Tools/rqanalyzerform/icons/q4/getting-the-most.png',
				value: 7
			},
			{
				answer: 'Growing My Investments and Assets',
				picRef: '/Tools/rqanalyzerform/icons/q4/growing.png',
				value: 10
			}
		]
	},
	{
		question: 'When I retire, how much will I rely on my investment income?',
		answers: [
			{
				answer: 'Heavily',
				picRef: '/Tools/rqanalyzerform/icons/q5/heavily.png',
				value: 1
			},
			{
				answer: 'Moderately',
				picRef: '/Tools/rqanalyzerform/icons/q5/moderately.png',
				value: 4
			},
			{
				answer: 'Somewhat',
				picRef: '/Tools/rqanalyzerform/icons/q5/somewhat.png',
				value: 7
			},
			{
				answer: 'Not at all.',
				picRef: '/Tools/rqanalyzerform/icons/q5/not-at-all.png',
				value: 10
			}
		]
	},
	{
		question:
			"You've unexpectedly received $10,000. What would you do with it if presented with the following options?",
		answers: [
			{
				answer:
					'Put it in a FDIC-insured bank account or certificate of deposit.',
				picRef: '/Tools/rqanalyzerform/icons/q6/FDIC.png',
				value: 1
			},
			{
				answer: 'Invest it in a diversified portfolio of stocks and bonds.',
				picRef: '/Tools/rqanalyzerform/icons/q6/diversified.png',
				value: 4
			},
			{
				answer: 'Invest it in high-quality bonds.',
				picRef: '/Tools/rqanalyzerform/icons/q6/bonds.png',
				value: 7
			},
			{
				answer: 'Invest it in a friend’s business venture.',
				picRef: '/Tools/rqanalyzerform/icons/q6/friend.png',
				value: 10
			}
		]
	},
	{
		question:
			"You're on a TV quiz show and have the following options. Which would you choose?",
		answers: [
			{
				answer: 'Walk away immediately with $5,000.',
				picRef: '/Tools/rqanalyzerform/icons/q7/guaranteed.png',
				value: 1
			},
			{
				answer: 'Play for a 50 percent chance of winning $25,000.',
				picRef: '/Tools/rqanalyzerform/icons/q7/50percent.png',
				value: 4
			},
			{
				answer: 'Play for a 25 percent chance of winning $50,000.',
				picRef: '/Tools/rqanalyzerform/icons/q7/25percent.png',
				value: 7
			},
			{
				answer: 'Play for a 5 percent chance of winning $500,000.',
				picRef: '/Tools/rqanalyzerform/icons/q7/5percent.png',
				value: 10
			}
		]
	},
	{
		question:
			'During the financial crisis in late-2008 and early-2009, the overall stock market lost more than 30 percent of its value. If you had investments that lost that amount in less than a year, what action would you take:',
		answers: [
			{
				answer: 'Sell my investments and put the money in something safe.',
				picRef: '/Tools/rqanalyzerform/icons/q8/sell.png',
				value: 1
			},
			{
				answer: 'Sell a portion of my investments to limit further loss.',
				picRef: '/Tools/rqanalyzerform/icons/q8/sell-some.png',
				value: 4
			},
			{
				answer: 'Hold my investments and do nothing.',
				picRef: '/Tools/rqanalyzerform/icons/q8/hold.png',
				value: 7
			},
			{
				answer: 'Invest more money to take advantage of lower prices.',
				picRef: '/Tools/rqanalyzerform/icons/q8/lower-prices.png',
				value: 10
			}
		]
	},
	{
		question:
			'How would those who know you best describe your attitude towards risk?',
		answers: [
			{
				answer: 'They would call me a gambler.',
				picRef: '/Tools/rqanalyzerform/icons/q9/gambler.png',
				value: 1
			},
			{
				answer:
					'They would say I’m willing to take risks after I gather information.',
				picRef: '/Tools/rqanalyzerform/icons/q9/gather-info.png',
				value: 4
			},
			{
				answer: 'They would say I’m cautious.',
				picRef: '/Tools/rqanalyzerform/icons/q9/cautious.png',
				value: 7
			},
			{
				answer:
					'They would say that I never take risks and always play it safe.',
				picRef: '/Tools/rqanalyzerform/icons/q9/safe.png',
				value: 10
			}
		]
	},
	{
		question: 'How sufficient are your reserves to handle emergency expenses?',
		answers: [
			{
				answer: 'None. I am living Paycheck to paycheck.',
				picRef: '/Tools/rqanalyzerform/icons/q10/unstable.png',
				value: 1
			},
			{
				answer:
					'Minimal. I have some cash set aside to handle small emergencies.',
				picRef: '/Tools/rqanalyzerform/icons/q10/minimal.png',
				value: 4
			},
			{
				answer:
					'Moderate. I could cover most emergencies, but it might strain my budget and my ability to save.',
				picRef: '/Tools/rqanalyzerform/icons/q10/moderate.png',
				value: 7
			},
			{
				answer:
					'Substantial. I have a significant amount of reserves, so I could cover nearly any emergency, including medical costs, job loss, and more.',
				picRef: '/Tools/rqanalyzerform/icons/q10/substantial.png',
				value: 10
			}
		]
	},
	{
		question:
			'How likely are you to make an investment based solely on a casual conversation with a friend, coworker, or family member?',
		answers: [
			{
				answer: 'Not likely at all. I only invest in things I have researched.',
				picRef: '/Tools/rqanalyzerform/icons/q11/research.png',
				value: 1
			},
			{
				answer:
					'Somewhat unlikely. It would have to be a very attractive opportunity.',
				picRef: '/Tools/rqanalyzerform/icons/q11/attractive.png',
				value: 4
			},
			{
				answer:
					'Somewhat likely. But that’s only if I trust the other person’s judgement.',
				picRef: '/Tools/rqanalyzerform/icons/q11/trust.png',
				value: 7
			},
			{
				answer: 'Very likely. I’m always looking for an exciting opportunity.',
				picRef: '/Tools/rqanalyzerform/icons/q11/excitement.png',
				value: 10
			}
		]
	},
	{
		question: 'Including all sources, my current household income is:',
		answers: [
			{
				answer: 'Under $50,000',
				picRef: '/Tools/rqanalyzerform/icons/q12/under50.png',
				value: 'Under $50,000'
			},
			{
				answer: '$50,001 - $100,000',
				picRef: '/Tools/rqanalyzerform/icons/q12/50100.png',
				value: '50,001 - 100,000'
			},
			{
				answer: '$100,001 - $250,000',
				picRef: '/Tools/rqanalyzerform/icons/q12/100250.png',
				value: '100,001 - 250,000'
			},
			{
				answer: '250,001+',
				picRef: '/Tools/rqanalyzerform/icons/q12/250000.png',
				value: '250,001+'
			}
		]
	}
];



// WEBPACK FOOTER //
// ./src/data/calcContent.js